import Vue from 'vue'
import FeatherIcon from '../components/FeatherIcon.vue'
import MaariMaLogo from '../components/logos/MaariMaLogo.vue'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component(MaariMaLogo.name, MaariMaLogo)

const loadComponent = require.context('@/components/generic', true, /Vx.+\.vue$/)
loadComponent.keys().forEach((filePath) => {
    // load the component
    var module = loadComponent(filePath)
    // module.default is the vue component
    Vue.component(module.default.name, module.default)
})

// v-select component
import vSelect from 'vue-select'

const components = require.context('@/components/generic', true, /Vx.+\.vue$/, 'lazy')
components.keys().forEach((filePath) => {
    // load the component
    components(filePath).then((module) => {
        // module.default is the vue component
        Vue.component(module.default.name, module.default)
    })
})

// Set the components prop default to return our fresh components
vSelect.props.components.default = () => ({
    Deselect: {
        render: (createElement) =>
            createElement('feather-icon', {
                props: {
                    icon: 'XIcon',
                    svgClasses: 'w-4 h-4 mt-1'
                }
            })
    },
    OpenIndicator: {
        render: (createElement) =>
            createElement('feather-icon', {
                props: {
                    icon: 'ChevronDownIcon',
                    svgClasses: 'w-5 h-5'
                }
            })
    }
})

Vue.component(vSelect)
